import { api } from './_client';
import type {
  PlannedFlight,
  PlannedFlightCreate,
  PlannedFlightUpdate,
  OperationsEquipment,
  OperationsEquipmentCreate,
  OperationsEquipmentUpdate,
  PlannedFlightEquipment,
} from '../../types/api';

export const operationsApi = {
  // === Planned Flights (Operations Calendar) ===

  async getPlannedFlights(dateFrom?: string, dateTo?: string): Promise<PlannedFlight[]> {
    const params: Record<string, string> = {};
    if (dateFrom) params.date_from = dateFrom;
    if (dateTo) params.date_to = dateTo;
    const response = await api.get<PlannedFlight[]>('/api/planned-flights', { params });
    return response.data;
  },

  async createPlannedFlight(data: PlannedFlightCreate): Promise<PlannedFlight> {
    const response = await api.post<PlannedFlight>('/api/planned-flights', data);
    return response.data;
  },

  async updatePlannedFlight(flightId: string, data: PlannedFlightUpdate): Promise<PlannedFlight> {
    const response = await api.put<PlannedFlight>(
      `/api/planned-flights/${encodeURIComponent(flightId)}`,
      data
    );
    return response.data;
  },

  async deletePlannedFlight(flightId: string): Promise<void> {
    await api.delete(`/api/planned-flights/${encodeURIComponent(flightId)}`);
  },

  // === Operations Equipment ===

  async getOperationsEquipment(): Promise<OperationsEquipment[]> {
    const response = await api.get<OperationsEquipment[]>('/api/equipment');
    return response.data;
  },

  async createOperationsEquipment(data: OperationsEquipmentCreate): Promise<OperationsEquipment> {
    const response = await api.post<OperationsEquipment>('/api/equipment', data);
    return response.data;
  },

  async updateOperationsEquipment(
    equipmentId: string,
    data: OperationsEquipmentUpdate
  ): Promise<OperationsEquipment> {
    const response = await api.put<OperationsEquipment>(
      `/api/equipment/${encodeURIComponent(equipmentId)}`,
      data
    );
    return response.data;
  },

  async deleteOperationsEquipment(equipmentId: string): Promise<void> {
    await api.delete(`/api/equipment/${encodeURIComponent(equipmentId)}`);
  },

  async getFlightEquipment(flightId: string): Promise<PlannedFlightEquipment[]> {
    const response = await api.get<PlannedFlightEquipment[]>(
      `/api/equipment/flight/${encodeURIComponent(flightId)}`
    );
    return response.data;
  },

  async assignEquipmentToFlight(
    flightId: string,
    equipmentId: string
  ): Promise<PlannedFlightEquipment> {
    const response = await api.post<PlannedFlightEquipment>(
      `/api/equipment/flight/${encodeURIComponent(flightId)}/${encodeURIComponent(equipmentId)}`
    );
    return response.data;
  },

  async removeEquipmentFromFlight(flightId: string, equipmentId: string): Promise<void> {
    await api.delete(
      `/api/equipment/flight/${encodeURIComponent(flightId)}/${encodeURIComponent(equipmentId)}`
    );
  },
};
